import React from "react";
import { motion } from "framer-motion";
import "./Perfonce.css";

import performanceImg from "../../../assets/images/Performance-mgmt.webp";
import recruitmentImg from "../../../assets/images/Recruitment-mgmt.webp";
import hrHelpDeskImg from "../../../assets/images/cyber-secure.webp";


const sections = [
  {
  title: "PERFORMANCE MANAGEMENT",
  desc: `Regular performance management with RapidHR encourages your employees to aim for excellence. This helps your organization achieve consistent success and sustainable growth.`,
  points: [
    "360 Performance reviews and templates",
    "Management By Objectives (MBO)",
    "Self-Evaluation tools",
    "Detailed performance reports",
  ],
  img: performanceImg,
},
{
  title: "RECRUITMENT MANAGEMENT",
  desc: `Accomplish the high-volume process of sourcing, tracking, and recruiting the best talent aligned with your business on a single, centralized platform.`,
  points: [
    "Efficient & flexible hiring",
    "Digital offer process management",
    "Advanced tracking & analytics",
    "Letters & mail merge automation",
  ],
  img: recruitmentImg,
},
{
  title: "HR HELP DESK",
  desc: `Provide incomparable support to your employees wherever they are, anytime they need it, with an efficient, automated, and advanced HR help desk system. It serves as a single point of contact for HR-related queries, policies, and benefits.`,
  points: [
    "Improved analytics and reporting",
    "Centralized information and employee support",
    "Clear HR policies and practices access",
    "Fast and effective issue resolution",
  ],
  img: hrHelpDeskImg,
},


 ,
];

const HRPlatformSection = () => {
  return (
    <section className="hrps-wrapper">
      {/* Heading */}
      

      {/* Sections */}
      {sections.map((item, index) => (
        <motion.div
          key={index}
          className={`hrps-section ${
            index % 2 !== 0 ? "reverse" : ""
          }`}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {/* Content */}
          <div className="hrps-content">
            <h3>{item.title}</h3>
            <p className="hrps-desc">{item.desc}</p>

            <ul className="hrps-list">
              {item.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>

          {/* Image */}
          <div className="hrps-image">
            <img src={item.img} alt={item.title} />
          </div>
        </motion.div>
      ))}
    </section>
  );
};

export default HRPlatformSection;
